import { TOGGLE_NOTIFICATION_LIST } from 'actions/Types';

export default status => {
  return dispatch => {
    const action = {
      type: TOGGLE_NOTIFICATION_LIST,
      payload: status
    };

    dispatch(action);
  };
};
